import { globalLogger } from './src/utils/logger';
// Initialize global logger as early as possible
globalLogger.init();

import React from 'react';
import ReactDOM from 'react-dom/client';
import './src/index.css';
import App from './App';
import { DevConsole } from './src/components/DevConsole';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
    <DevConsole />
  </React.StrictMode>
);